import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { BASE_API } from '../../api/Globals';
import Menu from '../../components/sturtural/Menu';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import { helpHttp } from '../../helpers/helpHttp';
import { storage } from '../../helpers/storage';

const estatus = [
    { label: 'Todos', value: 0 },
    { label: 'Pendientes', value: 1 },
/*     { label: 'Entregado completo', value: 4 },
 */    { label: 'Entregado parcial', value: 6 },
];

const getReporte = [
    { label: 'General', value: 1 },
    { label: 'Por nivel', value: 2 },
    { label: 'Por CT', value: 3 },
];

const getEntrega = [
    { name: 'Todos', code: 0 },
    { name: 'Focalizado', code: 1 },
    { name: 'Sede', code: 2 },
]

const initForm = {
    tipoReporte: getReporte[0].value,
    municipio: null,
    localidad: null,
    nivel: null,
    supervicion: null,
    tipoEntrega: getEntrega[0],
    ct: '',
    estado: estatus[0].value
}


const ReporteMaquila = () => {
    const navigate = useNavigate();
    const [municipios, setMunicipios] = useState([]);
    // const [getReporte, setGetReporte] = useState([]);
    const [getLocalidad, setGetLocalidad] = useState([]);
    const [getNivel, setGetNivel] = useState([]);
    const [getSupervicion, setGetSupervicion] = useState([]);
    // const [getUniverso, setGetUniverso] = useState([]);
    // const [municipio, setMunicipio] = useState(null);
    // const [ct, setCt] = useState('');
    // const [estado, setEstado] = useState(estatus[0].value)
    const [selectedSuperviciones, setSelectedSuperviciones] = useState([])
    const [form, setForm] = useState(initForm)
    const [loading, setLoading] = useState(false);
    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(false);
    const perfil = storage.get('perfilid');
    const ciclo = storage.get('ciclo');


    useEffect(() => {
        if (![1, 5, 3, 19].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        async function obtenerDrops() {
            const resMuni = await helpHttp().post(`${BASE_API}Escuela/CargarMunicipios`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                const todos = { IdMunicipio: 0, Municipio: 'Todos' }
                res.unshift(todos);
                setMunicipios(res);
                return res
                // getLocalidades(res[0]);
            })

            const resNivel = await helpHttp().get(`${BASE_API}BusquedaAlumnos/GetRptNivel`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                const todos = { code: 0, name: 'Todos' }
                res.ITEMS.ITEMS.unshift(todos);
                setGetNivel(res.ITEMS.ITEMS);
                return res.ITEMS.ITEMS;
            })
            getLocalidades(resMuni[0], resNivel[0])
        }
        obtenerDrops()
    }, [])

    const handlerRedirect = () => {
        setAviso(false);
    }

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'municipio':
                getLocalidades(value, form.nivel);
                break;
            case 'localidad':
                setForm({
                    ...form,
                    [name]: value,
                })
                setSelectedSuperviciones([])
                break;
            default:
                setForm({
                    ...form,
                    [name]: value,
                })
                break;
        }

    }

    const getLocalidades = (municipio, nivel) => {
        if (municipio.IdMunicipio !== 0) {
            helpHttp().post(`${BASE_API}Escuela/CargarLocalidades/${municipio.IdMunicipio}`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.length > 0) {
                    /*     [1].includes(parseInt(perfil)) && res.unshift({
                           IdLocalidad: 0,
                            Localidad: 'Todos'
                        }) */
                    setGetLocalidad(res)
                    getSuperviciones(municipio, res[0], nivel)
                    // setForm({
                    //     ...form,
                    //     nivel: nivel,
                    //     municipio: municipio,
                    //     localidad: res[0]
                    // });
                }
            })
        } else {
            let item = [{ IdLocalidad: 0, Localidad: 'Todos' }];
            setGetLocalidad(item);
            getSuperviciones(municipio, item[0], nivel)
            // setForm({
            //     ...form,
            //     nivel: nivel,
            //     municipio: municipio,
            //     localidad: item[0]
            // })
        }
    }

    const getSuperviciones = (municipio, localidad, nivel) => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                "sp": "SpdListarSupervisiones",
                "Tipo": 0,
                "parametros": [
                    { "IdMunicipio": municipio.IdMunicipio },
                    { "IdLocalidad": localidad.IdLocalidad },
                    { "IdCicloEscolar": ciclo.IdCicloEscolar },
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setGetSupervicion(res.ITEMS);
                setForm({
                    ...form,
                    nivel: nivel,
                    municipio: municipio,
                    localidad: localidad,
                    ct: '',
                    supervicion: res.ITEMS[0]
                })
                setSelectedSuperviciones([])
            }
        })
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            // console.log(module)
            // if (module && module.default) {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });

            module.saveAs(data, fileName + EXCEL_EXTENSION);
            // }
        });
        setLoading(false)
    };

    const obtenerBase64 = () => {
        if (selectedSuperviciones.length > 0) {
            GenerarReporteMulti()
        } else {
            GenerarReporte()
        }
    }

    const GenerarReporteMulti = async () => {
        setLoading(true)
        const files = await Promise.all(
            selectedSuperviciones.map(async (supervision) => {
                return await helpHttp().post(`${BASE_API}BusquedaAlumnos/SpdRptMaquilaPendientes`, {
                    body: {
                        Opcion: 1,
                        CT: null,
                        IdMunicipio: form.municipio.IdMunicipio,
                        parametroExtras: `[{
                            "IdCicloEscolar": ${ciclo.IdCicloEscolar},
                            "IdLocalidad": ${form.localidad.IdLocalidad},
                            "Supervision": "${supervision}",
                            "IdNivel": ${form.nivel.code},
                            "IdStatus": ${form.estado},
                            "TipoEntrega": ${form.tipoEntrega.code}
                        }]`
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(res => {
                    if (res.SUCCESS) {
                        if (res.ITEMS.length > 0) {
                            return res.ITEMS
                        } else {
                            return [{ "SUPERVISIÓN": supervision, "estatus": false }];
                        }
                    }
                })
            })
        )
        const flat = files.flat();
        switch (form.tipoReporte) {
            case 1:
                general(flat.filter(x => x.estatus !== false));
                break;
            case 2:
                porNivel(flat.filter(x => x.estatus !== false));
                break;
            case 3:
                porCT(flat.filter(x => x.estatus !== false));
                break;
        }
        if (flat.some(x => x.estatus === false)) {
            setAviso(true);
            setMessage(`Búsqueda sin resultados: \n ${flat.filter(x => x.estatus === false).map(j => j.SUPERVISIÓN)}`)
            setLoading(false);
        }
    }

    const GenerarReporte = () => {
        setLoading(true);
        if (form.municipio !== null) {
            helpHttp().post(`${BASE_API}BusquedaAlumnos/SpdRptMaquilaPendientes`, {
                body: {
                    Opcion: 1,
                    CT: form.ct.trim(),
                    IdMunicipio: form.municipio.IdMunicipio,
                    parametroExtras: `[{
                        "IdCicloEscolar": ${ciclo.IdCicloEscolar},
                        "IdLocalidad": ${form.localidad.IdLocalidad},
                        "IdNivel": ${form.nivel.code},
                        "Supervision": "0",
                        "IdStatus": ${form.estado},
                        "TipoEntrega": ${form.tipoEntrega.code}
                    }]`
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    if (res.ITEMS.length > 0) {
                        switch (form.tipoReporte) {
                            case 1:
                                general(res.ITEMS);
                                break;
                            case 2:
                                porNivel(res.ITEMS);
                                break;
                            case 3:
                                porCT(res.ITEMS);
                                break;
                        }
                    } else {
                        setAviso(true);
                        setMessage('Búsqueda sin resultados')
                        setLoading(false);
                    }
                }
            })
        }
    }

    const general = (contenido) => {
        import('xlsx').then((xlsx) => {
            const worksheet1 = xlsx.utils.json_to_sheet(contenido);
            const workbook = { Sheets: { [form.municipio.Municipio]: worksheet1 }, SheetNames: [`${form.municipio.Municipio}`], };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });
            saveAsExcelFile(excelBuffer, `Reporte_${form.municipio.Municipio}_${new Date().toLocaleDateString('en-GB')}_${form.tipoEntrega.name}_${ciclo.Descripcion}`);
        });
    }
    const porNivel = (contenido) => {
        const niveles = Object.groupBy(contenido, ({ NIVEL }) => NIVEL)
        // console.log(niveles)

        import('xlsx').then((xlsx) => {
            const workbook = { Sheets: {}, SheetNames: [] }
            for (const [key, value] of Object.entries(niveles)) {
                workbook.Sheets[key] = xlsx.utils.json_to_sheet(value);
                workbook.SheetNames.push(key)
            }
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });
            saveAsExcelFile(excelBuffer, `Reporte_${form.municipio.Municipio}_${new Date().toLocaleDateString('en-GB')}_${form.tipoEntrega.name}_${ciclo.Descripcion}`);
        });
    }
    const porCT = (contenido) => {
        console.log(contenido)
        const ct = Object.groupBy(contenido, ({ CCT }) => CCT)
        console.log(ct)
        import('xlsx').then((xlsx) => {
            const workbook = { Sheets: {}, SheetNames: [] }
            for (const [key, value] of Object.entries(ct)) {
                workbook.Sheets[key] = xlsx.utils.json_to_sheet(value);
                workbook.SheetNames.push(key)
            }
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });
            saveAsExcelFile(excelBuffer, `Reporte_${form.municipio.Municipio}_${new Date().toLocaleDateString('en-GB')}_${form.tipoEntrega.name}_${ciclo.Descripcion}`);
        });
    }

    const seleccionarSupervisiones = (e) => {
        setSelectedSuperviciones(e)
        form.ct !== '' && setForm({...form, ct: ''})
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect()} icon="pi pi-check" className="p-button-primary" />;

    return (
        <>
            <Menu link='reporte-general' />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h3>Reporte maquila</h3>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="tipoRreporte">Tipo de reporte:</label>
                                <Dropdown id="tipoReporte" value={form.tipoReporte} options={getReporte} name="tipoReporte" placeholder="Elige un reporte" onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="tipoEntrega">Tipo de entrega:</label>
                                <Dropdown id="tipoEntrega" value={form.tipoEntrega} optionLabel='name' options={getEntrega} name="tipoEntrega" placeholder="Elige un tipo de entrega" onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="estado">Estatus:</label>
                                <Dropdown id="estado" value={form.estado} options={estatus} name="estado" optionLabel="label" optionValue='value' onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="municipio">Municipio:</label>
                                <Dropdown id="municipio" value={form.municipio} options={municipios} name="municipio" optionLabel="Municipio" placeholder="Elige un municipio" filter onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="localidad">Localidad:</label>
                                <Dropdown id="localidad" value={form.localidad} options={getLocalidad} optionLabel='Localidad' name="localidad" placeholder="Elige una localidad" filter onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="supervicion">Supervisión:</label>
                                <MultiSelect id="supervision" filter name="supervision" value={selectedSuperviciones} options={getSupervicion} optionLabel="descripcion" optionValue="id" onChange={(e) => { seleccionarSupervisiones(e.target.value) }} />
                                {/* <Dropdown id="supervicion" value={form.supervicion} options={getSupervicion} optionLabel='descripcion' name="supervicion" placeholder="Elige una supervicion" filter onChange={handleOnChange} /> */}
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="nivel">Nivel:</label>
                                <Dropdown id="nivel" value={form.nivel} options={getNivel} optionLabel='name' name="nivel" placeholder="Elige un nivel" onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="ct">Clave CT:</label>
                                <InputText value={form.ct} disabled={(selectedSuperviciones.length > 0 || (form.municipio !== null && form.localidad !== null && (form.municipio.IdMunicipio > 0 || form.localidad.IdLocalidad > 0))) ? true : false} id="ct" name="ct" type="text" placeholder='Todos' onChange={handleOnChange} />
                            </div>
                        </div>
                        <div className="p-dialog-footer">
                            <div className=" border-top-1 surface-border pt-3 text-right">
                                <Button
                                    type='button'
                                    name="button-generar"
                                    id="button-generar"
                                    disabled={loading}
                                    icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel')}
                                    label="Generar"
                                    onClick={() => obtenerBase64()}

                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog header="Aviso" draggable={false} closable={false} visible={aviso} onHide={() => setMessage(false)} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default ReporteMaquila;